import { Provider } from '@angular/core';
import { STEP_UP_GATE } from '@asm/components-core/services/step-up-gate';
import { StepUpService } from '../services/step-up.service';

export function provideAsmStepUp(): Provider[] {
  return [{ provide: STEP_UP_GATE, useExisting: StepUpService }];
}
